module.exports = __webpack_public_path__ + "img/IMG-20200308-WA0246.eab3ec4c.jpg";